<template>
    <div class="service-page">
        <div class="block vw-service-block">
            <div class="service-item" v-if="service.serviceCenter">
                <strong class="block-title">{{isCn ? service.serviceCenter.cnName : service.serviceCenter.enName}}</strong>
                <i class="block-title-line"></i>
                <div class="style-1" v-if="service.serviceCenter.mode===1">
                    <div class="main-image" v-if="service.imageArray.length">
                        <q-carousel
                            class="my-carousel"
                            style="width: 100%;height:100%"
                            animated
                            v-model="photoIndex"
                            infinite
                            autoplay
                            :navigation="service.imageArray.length > 1"
                            swipeable
                            transition-prev="slide-right"
                            transition-next="slide-left"
                        >
                            <q-carousel-slide v-for="(image, index) in service.imageArray" :key="index" :name="index" :img-src="image" />
                        </q-carousel>
                    </div>
                    <div class="content main-content editor-gen" v-html="isCn ? service.serviceCenter.cnContentOne : service.serviceCenter.enContentOne"></div>
                    <div class="foot-image" v-if="isCn && service.serviceCenter.cnMobileImage">
                        <img v-for="(img, index) in service.serviceCenter.cnMobileImage.split(',')" :key="index" :src="img" alt="">
                    </div>
                    <div class="foot-image" v-if="!isCn && service.serviceCenter.enMobileImage">
                        <img v-for="(img, index) in service.serviceCenter.enMobileImage.split(',')" :key="index" :src="img" alt="">
                    </div>
                </div>
                <div class="style-2" v-if="service.serviceCenter.mode===2">
                    <div class="text-image">
                        <div class="main-image" v-if="service.imageArray.length">
                            <q-carousel
                                class="my-carousel"
                                style="width: 100%;height:100%"
                                animated
                                v-model="photoIndex"
                                infinite
                                autoplay
                                :navigation="service.imageArray.length > 1"
                                swipeable
                                transition-prev="slide-right"
                                transition-next="slide-left"
                            >
                                <q-carousel-slide v-for="(image, index) in service.imageArray" :key="index" :name="index" :img-src="image" />
                            </q-carousel>
                        </div>
                        <div class="content main-content editor-gen" v-html="isCn ? service.serviceCenter.cnContentOne : service.serviceCenter.enContentOne"></div>
                    </div>
                    <div class="content foot-content editor-gen" v-html="isCn ? service.serviceCenter.cnContentTwo : service.serviceCenter.enContentTwo"></div>
                </div>
                <div class="style-3" v-if="service.serviceCenter.mode===3" :itemIndex="i" v-touch-swipe.touch.left.right="serviceSwipe">
                    <ul class="main-image" :style="{transform: `translate(${serviceTrans}, 0)`, marginLeft: serviceMargin}">
                        <li v-for="image in service.modeThreeImageList" :key="image.key">
                            <img :src="image.listImage" alt="" @click="showDetailImg(image, service.serviceCenter)">
                        </li>
                    </ul>
                </div>
                <div class="style-4" v-if="service.serviceCenter.mode===4">
                    <img class="main-image" :src="isCn ? service.serviceCenter.cnMobileImage : service.serviceCenter.enMobileImage" alt="">
                </div>
            </div>
        </div>
        <q-dialog v-model="showDetail" :maximized="true" persistent>
            <div class="detail-img">
                <div class="back-nav">
                    <div class="back-icon" @click="showDetail=false">
                        <img :src="back" alt="">
                    </div>
                    <div class="strong">{{titleDetail}}</div>
                </div>
                <img :src="srcDetail" alt="">
                <router-link
                    v-if="buyLink"
                    :to="{ name: 'buy', params: { id: buyLink }}"
                    class="buy-btn"
                >立即购买</router-link>
            </div>
        </q-dialog>
    </div>
</template>

<script>
import backSrc from '@/style/image/back.png';
import main from '@/utils/main';
import getLang from '@/utils/main/lang';
import Layout from '@/views/Layout.vue';
import ajax from '@/utils/ajax';
import router from '@/router';

export default {
    name: 'serviceCenter',
    components: {
        Layout,
    },
    props: {
        pageId: Number,
    },
    data() {
        return {
            isCn: window.localStorage.getItem('show-lang') !== 'en',
            lang: getLang(),
            back: backSrc,
            service: {},
            serviceIndex: 0,
            serviceMarginIndex: 0,
            photoIndex: 0,
            showDetail: false,
            srcDetail: null,
            buyLink: null,
            titleDetail: '',
            playIndex: 0,
        };
    },
    computed: {
        serviceTrans() {
            const screenWidth = window.innerWidth;
            return `${-this.serviceIndex * 163 * screenWidth / 375}px`;
        },
        serviceMargin() {
            const self = this;
            const screenWidth = window.innerWidth;
            return `${-(self.serviceMarginIndex * 163 - 105) * screenWidth / 375}px`;
        },
    },
    mounted() {
        ajax.get('/web/service_center/detail.json', {
            id: this.$props.pageId,
        }).then((result) => {
            const serviceCenter = result.data;
            if (serviceCenter.mode === 1 || serviceCenter.mode === 2) {
                this.photoIndex = 0;
            } else if (serviceCenter.mode === 3) {
                this.serviceIndex = 2;
                this.serviceMarginIndex = 0;
                serviceCenter.modeThreeImageList = serviceCenter.modeThreeImageList.map((img, pos) => {
                    img.key = pos;
                    return img;
                });
            }
            this.service = serviceCenter;
            this.startPlay();
        }).catch(() => {});
    },
    destroyed() {
        window.clearInterval(this.playIndex);
    },
    methods: {
        goBack() {
            router.go(-1);
        },
        startPlay() {
            const self = this;
            window.clearInterval(this.playIndex);
            this.playIndex = window.setInterval(() => {
                if (typeof v !== 'number') {
                    return;
                }
                self.serviceIndex += 1;
                setTimeout(() => {
                    self.service.modeThreeImageList.push(self.service.modeThreeImageList.shift());
                    self.serviceMarginIndex -= 1;
                    self.service = main.copy(self.service);
                }, 450);
            }, 3000);
        },
        serviceSwipe({ evt, ...info }) {
            const self = this;
            if (info.direction === 'left') {
                this.serviceIndex += 1;
                setTimeout(() => {
                    self.service.modeThreeImageList.push(self.service.modeThreeImageList.shift());
                    self.serviceMarginIndex -= 1;
                    self.service = main.copy(self.service);
                }, 450);
            } else if (info.direction === 'right') {
                this.serviceIndex -= 1;
                setTimeout(() => {
                    self.service.modeThreeImageList.unshift(self.service.modeThreeImageList.pop());
                    self.serviceMarginIndex += 1;
                    self.service = main.copy(self.service);
                }, 450);
            }
        },
        showDetailImg(image, serviceCenter) {
            this.showDetail = true;
            this.buyLink = image.productCode || null;
            this.srcDetail = this.isCn ? image.cnMobileImage : image.enMobileImage;
            this.titleDetail = this.isCn ? serviceCenter.cnName : serviceCenter.enName;
        },
    },
};
</script>
<style lang="less" scoped>
    .vw-service-block {
        padding-bottom: 15px;
    }
    .vw-service-block .service-item {
        display: block;
        position: relative;
        margin: 5px 0;
        width: 375px;
        background: #fff;
        text-align: center;
        .block-title {
            display: block;
            padding-top: 8px;
            font-size: 14px;
            font-weight: 600;
            text-align: center;
        }
        .block-title-line {
            margin-top: 6px;
            display: block;
            margin: 0 auto;
            width: 22px;
            height: 2px;
            background: #C71F4B;
        }
    }
    .style-1 {
        padding: 10px 0;
        .main-content {
            padding-top: 8px;
            width: 100%;
            height: auto;
        }
        .foot-image {
            display: block;
            margin: 0 15px;
            height: auto;
            img {
                width: 100%;
                height: auto;
            }
        }
    }
    .vw-service-block .style-1 {
        .main-image {
            display: block;
            margin: 0 15px;
            height: 218px;
        }
    }
    .style-2 {
        padding: 10px 0;
        .foot-content {
            width: 100%;
            height: auto;
        }
    }
    .vw-service-block .style-2 {
        .text-image {
            display: flex;
            flex-wrap: nowrap;
            justify-content: flex-start;
            .main-image {
                display: block;
                margin-left: 15px;
                flex: 0 0 155px;
                height: 250px;
            }
            .main-content {
                flex: 1;
                height: auto;
            }
        }
    }
    .style-3 {
        padding: 10px 0;
    }
    .vw-service-block .style-3 {
        width: 375px;
        overflow: hidden;
        .main-image {
            transition: transform 0.4s linear;
            margin-left: 105px;
            display: flex;
            width: 375px;
            height: 250px;
            justify-content: flex-start;
            align-items: flex-end;
            flex-wrap: nowrap;
        }
        li {
            position: relative;
            flex: 0 0 155px;
            width: 155px;
            height: 250px;
            margin: 0 4px;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
    .style-4 {
        padding: 10px 15px;
        .main-image {
            display: block;
            width: 100%;
            height: auto;
        }
    }
    .back-nav {
        width: 100%;
        height: 44px;
        background: #fff;
        display: flex;
        justify-content: space-between;
        align-content: center;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 3;
        border-bottom: 1px solid #F1F1F1;
        .back-icon {
            width: 11px;
            height: 17px;
            margin-top: 14px;
            margin-left: 20px;
            z-index: 3;
            img {
                width: 100%;
                height: 100%;
            }
        }
        .strong {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            font-size: 15px;
            color: #4A4A4A;
            text-align: center;
            line-height: 44px;
            font-weight: 500;
            overflow: hidden;
            padding: 0 50px;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
    }
    .detail-img {
        padding-top: 44px;
        padding-bottom: 50px;
        background: #f1f1f1;
        img {
            display: block;
            width: 100%;
            height: auto;
        }
        .buy-btn {
            position: fixed;
            left: 0;
            bottom: 0;
            width: 100%;
            height: 50px;
            color: #fff;
            background: #C71F4B;
            line-height: 50px;
            text-align: center;
            font-size: 16px;
            z-index: 3;
        }
    }
</style>
